import React, { useState } from "react";
import { SectionContainer } from "./styles/styles";

import chevronDown from "./img/chevron-down.svg";
import chevronUp from "./img/chevron-up.svg";

const ExpandingContainer = ({ title, children }) => {
  const [expanded, setExpanded] = useState(true);
  return (
    <SectionContainer>
      <div className="title-bar" onClick={() => setExpanded(!expanded)}>
        <h2>{title}</h2>
        <img
          src={expanded ? chevronUp : chevronDown}
          alt={`chevron ${expanded ? "up" : "down"}`}
        />
      </div>
      {expanded && children}
    </SectionContainer>
  );
};

export default ExpandingContainer;
